import React from "react";
import { StateManager } from "../../rule-engine-core/Common/StateManager";
import { ObserveState } from "../StateManagement/ObserveState";
import { UIDatePicker } from "../BuildlingBlocks/UIDatePicker";
import { SxProps } from "@mui/material";
import { getPropertyEditorValidationIssues, PropertyEditorValidationTooltip } from "./PropertyEditorValidationTooltip";

export interface PropertyEditorDateInterface {
    editObject: object;
    propertyName: string;
    label?: string;
    hint?: string;
    autoFocus?: boolean;

    storeTime?: boolean;
    onChange?: () => void;
    sx?: SxProps;
    error?: string;
    ignoreDesignerValidation?: boolean;
}

export const PropertyEditorDate: React.FC<PropertyEditorDateInterface> = (props: PropertyEditorDateInterface) => {
    const onChange = (d: Date | undefined) => {
        Reflect.set(props.editObject, props.propertyName, d);
        StateManager.propertyChanged(props.editObject, props.propertyName);
        if (props.onChange) props.onChange();
    };

    return (
        <ObserveState
            listenTo={props.editObject}
            properties={[props.propertyName]}
            control={() => {
                let validationIssues = getPropertyEditorValidationIssues(
                    props.editObject,
                    props.propertyName,
                    props.error,
                );

                return (
                    <PropertyEditorValidationTooltip
                        editObject={props.editObject}
                        propertyName={props.propertyName}
                        error={validationIssues}
                    >
                        <UIDatePicker
                            sx={{ ...props.sx }}
                            value={Reflect.get(props.editObject, props.propertyName)}
                            label={props.label}
                            hint={props.hint}
                            showTime={props.storeTime}
                            error={validationIssues?.message}
                            onChange={onChange}
                            fullWidth={true}
                        />
                    </PropertyEditorValidationTooltip>
                );
            }}
        />
    );
};
